import { Publication } from "../hooks/types/publicationDataType";

export const MAX_OF_THREE = 3;
export const POSITION_PLUS = 1;
export const POSITION_MIN = 1;

/**
 * This method returns the object-format for the ChartJS BarGraph.
 * It needs the labels & datasets.
 * @param {Object} publications The publications you want to retrieve the labels & datasets from.
 * @param {function} setLoaded A state to tell if the data has been extracted.
 * @return {Object} It returns an object with the labels & datasets.
 */
export const getTopThreeGraphData = (publications: Publication[], setLoaded: any): any => {
	const amount = setTopThreeAmount(publications);
	const topThree: any[] = getTopThreeVisitors(publications, amount);
	const labels = topThree.map(pub => pub.name);
	const data = topThree.map(pub => pub.uniqueVisitors);
	const datasets = [{
		label: `Top ${amount} publications`,
		backgroundColor: [
			"rgba(0, 174, 0, 0.6)",
			"rgba(146, 0, 220, 0.6)",
			"rgba(255, 155, 0, 0.6)"
		],
		borderColor: ["#00AE00", "#9200DC", "#FF9B00"],
		data: data,
		borderWidth: 1
	}];

	setLoaded(true);
	return { labels, datasets };
};
/**
 * This method returns an array with custom object of the publications.
 * This publication includes: id, name, uniqueVisitors.
 * @param {Object} publications The publications you want to extract the data from.
 * @param {number} amount the amount of docs for the graph.
 * @return {Object} It returns a sorted array of at most 3 objects
 * with the uniqueVisitors for each publication.
 */
const getTopThreeVisitors = (publications: Publication[], amount: number): any[] => {
	const temporary: any[] = [];
	const pubsWithVisitors: any[] = [];

	publications.forEach((publication) => {
		const id = publication.id;
		const name = publication.name;
		const uniqueVisitors = publication.data.uniqueVisitors;

		temporary.push({
			id: id,
			name: name,
			uniqueVisitors: uniqueVisitors
		});
	});

	temporary.sort((pubA: any, pubB: any) =>
		(pubA.uniqueVisitors < pubB.uniqueVisitors) ? POSITION_PLUS :POSITION_MIN);
	
	for (let i = 0; i < amount; i++) {
		pubsWithVisitors.push(temporary[i]);
	}
	return pubsWithVisitors;
};
/**
 * This method returns a number and checks if there are less that three docs
 * @param {Object} publications The publications you want to extract the data from.
 * @return {number} It returns a number.
 */
const setTopThreeAmount = (publications: any[]): number => {
	if (publications.length > MAX_OF_THREE)
		return MAX_OF_THREE;
	return publications.length;
};